import { format } from 'date-fns'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'

import Pagination from '@/compoments/common/Pagination'
import {
    selectListPagination,
    selectNotificationList,
} from '@/features/notifications/notificationsSlice'
import {
    useGetMyNotificationQuery,
    useMarkAllMyNotificationMutation,
    useMarkByIdMyNotificationMutation,
} from '@/services/notifications/notifications'
import type { INotification } from '@/types/notifications'
import { getNotificationIcon } from '../Dispatcher/NotificationManagerPage/components/NotificationMenu'

const NotificationPage = () => {
    const [searchParams] = useSearchParams()
    const qweryString = searchParams.toString()
    const [markAsRead] = useMarkByIdMyNotificationMutation()
    const [markAllAsRead] = useMarkAllMyNotificationMutation()
    const { data } = useGetMyNotificationQuery(qweryString)
    const containerRef = useRef<HTMLDivElement | null>(null)
    const pageData = data?.data
    const handleClearAll = async () => {
        await markAllAsRead('')
    }

    const groupNotificationByDay = (notifications: INotification[]) => {
        return notifications.reduce(
            (acc, notification) => {
                const dateKey = notification?.createdAt
                    ? format(new Date(notification.createdAt), 'yyyy-MM-dd')
                    : 'Unknown'
                if (!acc[dateKey]) acc[dateKey] = []
                acc[dateKey].push(notification)
                return acc
            },
            {} as Record<string, INotification[]>,
        )
    }

    const groupedNotifications = groupNotificationByDay(pageData || [])

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries
                    .filter((entry) => entry.isIntersecting)
                    .forEach(async (entry) => {
                        const id = entry.target.getAttribute('data-id')
                        if (id) await markAsRead(+id)
                    })
            },
            { root: containerRef.current, threshold: 0.5 },
        )

        const items = containerRef.current?.querySelectorAll('.unread[data-id]')
        items?.forEach((item) => observer.observe(item))

        return () => observer.disconnect()
    }, [pageData])

    // const handlePageChange = (page: number) => {
    //     // setCurrentPage(page)
    //     refetch()
    // }

    return (
        <main className="content">
            <div className="px-container">
                <div className="table-group mb-18 notification-page">
                    <div className="table-header capitalize">
                        <h5>Notifications</h5>
                        <button
                            onClick={handleClearAll}
                            className="btn btn--primary btn--sm"
                        >
                            Mark All as Read
                        </button>
                    </div>
                    <div
                        className="notification-page-wrapper"
                        ref={containerRef}
                    >
                        {Object.entries(groupedNotifications).map(
                            ([date, notifications], index) => (
                                <ul className="notification-list" key={index}>
                                    <li className="date-header">
                                        {format(new Date(date), 'PP')}
                                    </li>
                                    {notifications.map((notification) => (
                                        // <li
                                        //     key={notification.id}
                                        //     data-id={notification.id}
                                        //     className={`notification-item ${
                                        //         notification.isRead
                                        //             ? ''
                                        //             : 'unread'
                                        //     }`}
                                        // >
                                        //     <p>{notification.description}</p>
                                        //     <span>
                                        //         {format(
                                        //             new Date(
                                        //                 notification.createdAt,
                                        //             ),
                                        //             'PPpp',
                                        //         )}
                                        //     </span>
                                        // </li>
                                        <li
                                            key={index}
                                            className={`item-notification ${
                                                notification.isRead
                                                    ? ''
                                                    : 'unread'
                                            }`}
                                            data-id={notification.id}
                                        >
                                            <div className="btn-notification">
                                                <div className="notification-header">
                                                    <div className="notification-title">
                                                        <span className="noti-ico ico">
                                                            {getNotificationIcon(
                                                                notification.type,
                                                            )}
                                                        </span>
                                                        <p className="noti-title">
                                                            {notification.title}
                                                        </p>
                                                    </div>
                                                    <span className="noti-time">
                                                        {notification?.createdAt
                                                            ? format(
                                                                  new Date(
                                                                      notification?.createdAt,
                                                                  ),
                                                                  'HH:mm',
                                                              )
                                                            : ''}
                                                    </span>
                                                </div>
                                                <div className="notification-body">
                                                    <p className="noti-description">
                                                        {
                                                            notification.description
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            ),
                        )}
                    </div>
                </div>
                <Pagination
                    pagination={data?.pagination}
                    // onPageChange={handlePageChange}
                />
            </div>
        </main>
    )
}

export default NotificationPage
